import { render, staticRenderFns } from "./SalesChildList.vue?vue&type=template&id=a3c47bd8"
import script from "./SalesChildList.vue?vue&type=script&lang=js"
export * from "./SalesChildList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports